import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LightboxState } from '../../../components/interfaces/lightbox.interface';
@Injectable({
  providedIn: 'root'
})
export class CustomLightboxService {
  private readonly lightboxState = signal<LightboxState>({
    items: [],
    currentIndex: 0,
    isOpen: false,
    isOwner: false,
    experienceType: ''
  });

  private readonly lightboxStateSubject = new BehaviorSubject<LightboxState>(this.lightboxState());
  lightboxState$ = this.lightboxStateSubject.asObservable();

  openLightbox(items: any[], index: number, isOwner: boolean, experienceType: string) {
    this.updateLightboxState({ items, currentIndex: index, isOpen: true, isOwner: isOwner, experienceType: experienceType});
  }

  closeLightbox() {
    this.updateLightboxState({ items: [], currentIndex: 0, isOpen: false , isOwner: false, experienceType: ''});
  }

  nextItem() {
    const state = this.lightboxState();
    if (state.items.length === 0) {
      return;
    }
    const newIndex = (state.currentIndex + 1) % state.items.length;
    this.updateLightboxState({ ...state, currentIndex: newIndex });
  }

  prevItem() {
    const state = this.lightboxState();
    if (state.items.length === 0) {
      return;
    }
    const newIndex = (state.currentIndex - 1 + state.items.length) % state.items.length;
    this.updateLightboxState({ ...state, currentIndex: newIndex });
  }

  private updateLightboxState(state: LightboxState): void {
    this.lightboxState.set(state);
    this.lightboxStateSubject.next(state);
  }
}
